import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Conclusao from './conclusao';
import { toggleDoneAssociadoAction } from '../../../../store/associadoPJReducer/actions';

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    toggleDoneAssociadoAction,
  }, dispatch);

export default connect(
  null,
  mapDispatchToProps
)(Conclusao);
